<script setup lang="ts">
import type { BlockLogocloud, BlockLogocloudFile, File } from '~/types';

defineProps<{
  data: BlockLogocloud;
}>();

const { fileUrl } = useFiles();
</script>
<template>
  <BlockContainer>
    <TypographyTitle v-if="data?.title">{{ data?.title }}</TypographyTitle>
    <TypographyHeadline v-if="data?.headline" :content="data?.headline" size="lg" />
    <div class="flow-root mt-8 lg:mt-10">
      <div v-if="data.logos && data.logos.length > 0" class="grid gap-4 md:grid-cols-4 md:gap-8">
        <div
          v-for="(logo, fileIdx) in data?.logos as BlockLogocloudFile[]"
          :key="logo.id"
          v-motion
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
          }"
          :delay="250 + 100 * fileIdx"
          class="flex items-center justify-center p-8 border border-gray-500 rounded-card dark:border-gray-700 dark:bg-gray-200"
        >
          <NuxtLink v-if="logo.url" :href="logo.url" target="_blank" rel="noopener nofollow">
            <NuxtImg
              v-if="(logo.directus_files_id as File)?.id"
              :class="logo.custom_class"
              :src="(logo.directus_files_id as File)?.id"
              :alt="(logo.directus_files_id as File)?.description ?? ''"
              :title="(logo.directus_files_id as File)?.description ?? ''"
            />
          </NuxtLink>
          <NuxtImg
            v-if="(logo.directus_files_id as File)?.id && !logo.url"
            :class="logo.custom_class"
            :src="(logo.directus_files_id as File)?.id"
            :alt="(logo.directus_files_id as File)?.description ?? ''"
            :title="(logo.directus_files_id as File)?.description ?? ''"
          />
        </div>
      </div>
    </div>
  </BlockContainer>
</template>
